<template>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="$emit('closeModal')">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
              <div class="modal-container" @click.stop>
  
                <div class="modal-header row" style="justify-content: flex-end;">
                  <!-- <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                  </div> -->
                  <div class="col">
                    <button type="button" class="close" @click="$emit('closeModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
  
                <div class="modal-body" style="min-height:60vh">
                  <h2 class="title">Jalankan Paycheck</h2>
                  <h4 class="text-center mb-5">Tanggal: {{weekLabel}}</h4>
                  <form>
                    <div class="row row-space">
                      <div class="col-md-6">
                        <div class="input-group">
                          <label class="label">Attendance Bonus</label>
                          <input class="input--style-4" type="text" v-model="bonus.attendance_bonus" disabled>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="input-group">
                          <label class="label">KPI Multiplier</label>
                          <input class="input--style-4" type="text" v-model="bonus.kpi_multiplier" disabled>
                        </div>
                      </div>
                    </div>
                    <div class="row row-space mt-5">
                      <div class="col-md-6 offset-md-3 text-right">
                        <button type="button" class="btn btn-outline-danger" @click="form.labourers.splice(0)">Hilangkan Semua</button>
                        <button type="button" class="btn btn-success ml-3" @click="addAllLaborers">Tambah Semua</button>
                      </div>
                    </div>
                    <div class="row row-space">
                      <div class="col-md-6 offset-md-3">
                        <div class="input-group" style="padding-top:0">
                          <label class="label">Pekerja<span style="color: red;">*</span></label>
                          <MultiSelect
                            v-model="form.labourers"
                            :options="options.laborer.map(type => type.id)"
                            :custom-label="opt => options.laborer.find(x => x.id == opt).name"
                            :multiple="true"
                            placeholder="Pilih Pekerja"
                          ></MultiSelect>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col mt-5" style="text-align: center">
                        <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                        <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Jalankan</button>
                      </div>
                    </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
  </template>
  
  <script>
    import moment from 'moment';
    import MultiSelect from 'vue-multiselect';
  
    export default {
      data () {
        return {
          options : {
            laborer : [],
          },
          rangeConfig: {
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          form : {
            labourers : [],
            kpi_multiplier : this.bonus.kpi_multiplier,
            attendance_bonus : this.bonus.attendance_bonus,
            work_week_date : this.generateWorkWeekDate()
          }
        }
      },
      props : ['date', 'bonus'],
      components:{
        MultiSelect,
      },
      mounted () {
        this.fetchLaborer();
      },
      watch : {
        
      },
      computed : {
        weekLabel () {
          let startDate = moment([this.date.year, this.date.month-1])

          // Get first monday
          let firstMonday = moment(startDate).startOf('month').isoWeekday(8)
          if(firstMonday.date() == 8) firstMonday = firstMonday.isoWeekday(-6);

          for (var i = 1; i < this.date.week; i++) {
            firstMonday.add(7, 'days')
          }

          return `${firstMonday.format('MMM D YYYY')} - ${firstMonday.add(6, 'days').format('MMM D YYYY')}`;
        },
      },
      methods : {
        fetchLaborer () {
          // console.log('hi');
          this.$http.get(`/api/v1/masterData/labourer?pagination=false`)
          .then((resp)=>{
            this.options.laborer = resp.data.data
          })
          .catch((err)=>{console.log(err)})
        },
        addAllLaborers () {
          this.form.labourers.length = 0;
          this.form.labourers = this.options.laborer.map(x=>x.id)
        },
        generateWorkWeekDate () {
          let startDate = moment([this.date.year, this.date.month-1])

          // Get first monday
          let firstMonday = moment(startDate).startOf('month').isoWeekday(8)
          if(firstMonday.date() == 8) firstMonday = firstMonday.isoWeekday(-6);

          for (var i = 1; i < this.date.week; i++) {
            firstMonday.add(7, 'days')
          }

          return firstMonday.format('YYYY-MM-DD');
        },
        validateForm(){
          var valid = true;
          var error = [];
  
          if(this.form.labourers.length == 0 || this.form.labourers == null){//Laborer [Required]
            valid = false;
            error.push('Pekerja wajib diisi');
          }
  
          if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
          else return valid;
        },
        async submitForm(){
          let vm = this;
          if(vm.validateForm()){
            this.$http.post('/api/v1/paycheck', this.form)
            .then((resp)=>{
              // alert(`Partshop ${vm.form.name} has been created`);
              this.$store.dispatch('triggerAlert', [true, [`Paycheck telah berhasil dijalankan`]]);
              this.$emit('updateTable');
              this.$emit('closeModal');
            })
            .catch((err)=>{
              console.log(err);
              this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
            })
          }
        },
      }
    }
  </script>
  
  <style scoped>
  
  /* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
  input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
  }
  
  .input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  
  .input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
  }
  
  .input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
  }
  
  .label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
  }
  
  .radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  
  .radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
  }
  
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
  }
  
  .checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding:20px;
  }
  
  .input-group-icon {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /* ==========================================================================
      #TITLE made by Colorlib (https://colorlib.com)
      ========================================================================== */
  .title {
    font-size: 40px;
    color: #525252;
    margin-bottom: 20px;
    text-align: center;
  }
  </style>
  